import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useI18N } from "@sundae/react-hooks";
import { DateI18N, Text, toolkitCx, Tooltip } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { safariSafeDate } from "../../../utils/dates.utils";
import FadeInBasic from "../../FadeInView/FadeInBasic";

const TasteTestProjectRoadmap: FC = () => {
  const { currentLocale, t } = useI18N("taste-test");
  const {
    state: { tasteTest },
  } = useTasteTestContext();
  const roadmap = tasteTest?.projectDetails.roadmap;

  return (
    <FadeInBasic>
      <ol
        className={cx(
          "flex flex-col gap-8 border-l border-l-gray-300 dark:border-l-gray-600",
          toolkitCx.layout.spacing.left.md
        )}
      >
        {roadmap?.map(({ accomplished, description, dueDate, title }, index) => (
          <FadeInBasic key={`${title}-${index}`} transitionDelay={index !== 0 ? 125 * index : 0}>
            <li className="relative flex flex-col gap-1">
              <div
                className={cx("absolute -left-5 top-2.5 h-2 w-2 rounded-full", {
                  "bg-success": accomplished,
                  [toolkitCx.layout.background.separator]: !accomplished,
                })}
              />

              <DateI18N
                value={new Date(safariSafeDate(dueDate?.format || "") || "")}
                locale={currentLocale}
                formatOpts={{
                  dateStyle: "medium",
                }}
                variant="silent"
                size="xs"
                className="pt-1.5"
              />

              <Text tag="h3" weight="medium" variant={accomplished ? "success" : "normal"}>
                {title}
                {accomplished ? (
                  <>
                    {" "}
                    <Tooltip
                      trigger={
                        <div className="inline cursor-help">
                          <CheckCircleIcon className="inline h-4 w-4 text-success" />
                        </div>
                      }
                      tooltipLabel={t("detail.projectDetails.roadmap.accomplished")}
                    />
                  </>
                ) : (
                  ""
                )}
              </Text>

              <Text tag="p" size="sm" variant="muted">
                {description}
              </Text>
            </li>
          </FadeInBasic>
        ))}
      </ol>
    </FadeInBasic>
  );
};

export default TasteTestProjectRoadmap;
